/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-key */

import { usePayAnInvoiceFormData } from "@/store/payAnInvoiceFormsStore";
import { useEffect, useRef, useState } from "react";
import AppText from "../other/AppText";
import AppButton from "../buttons/AppButton";
import LoadingDots from "../other/LoadingDots";
import { usePostPaymentService } from "@/hooks/usePostPayment";
import { toast } from "sonner";
import { createPortal } from "react-dom";
import { GP_ERROR_MSG, OTHERS_SELECT_OPTION_CODE } from "./constants";
import { fetchFromAPI } from "@/app/[lang]/pay-an-invoice/apiService";
import { usePartialPaymentService } from "@/hooks/use-partial-paymment-service";
import APIClient from "@/app/[lang]/request-service/apiClient";

interface GetAddNewPaymentApiKeyResponse {
  iframeKey: string;
}

export interface EtAccKeyItem {
  DOC_NO: number;
  ITEM_NO: string;
  COMP_CODE: number;
  FISCAL_YEAR: number;
  BUKRS: number;
  GJAHR: number;
  BELNR: number;
  DECISION: "SUCCESS" | "FAILURE";
  REASON_TXT: string;
}

const reasonCode = "0006";

const sumOfPayment = (multiplePayments: any) => {
  const paymentArray = Object.values(multiplePayments);
  let sum = 0;
  paymentArray.forEach((item) => {
    sum += Number(item);
  });

  return Number.parseFloat(sum.toString()).toFixed(2).toString();
};

const FormRequestPayAnInvoiceStep3 = ({ formDataTab }: { formDataTab: any }) => {
  const {
    setStep,
    formData,
    customerInvoiceResponse,
    formDataSecondTab,
    setPaymentSuccessResponse,
    selectedInvoicesResponse,
    setPartialPaymentSuccess,
    setPortalAccountCreation,
  } = usePayAnInvoiceFormData();
  const { postPartialPayment } = usePartialPaymentService();
  const { postPayment } = usePostPaymentService();

  const [iframeLoad, setIframeLoad] = useState<number>(0);
  const invoiceLineItems = customerInvoiceResponse?.STATEMENT_LINES?.item?.[0].LINES.item[0];
  const invoiceStatementLine = customerInvoiceResponse?.STATEMENT_LINES?.item?.[0];

  const [externalKey, setExternalKey] = useState<GetAddNewPaymentApiKeyResponse>();
  const [gwUrl, setGwUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [backDisable, setBackDisable] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState(true);
  const isCheckedRef = useRef(isChecked);
  const userType = usePayAnInvoiceFormData((state) => state.userType);

  const filteredPartialPayments: {
    Payment_amount: string;
    Selected_option: string;
    Reason: string;
    isDisable: string;
    enteredReason: string;
    DOC_NO: any;
    statement: any;
  }[] = [];

  customerInvoiceResponse?.STATEMENT_LINES?.item.forEach((statement: any) => {
    const docNo = statement.DOC_NO.toString();
    const balance = parseFloat(statement.BALANCE);
    const payment = parseFloat(formDataSecondTab.Payment_amount[docNo] || "0");

    if (payment < balance) {
      filteredPartialPayments.push({
        Payment_amount: formDataSecondTab.Payment_amount[docNo],
        Selected_option: formDataSecondTab.Selected_option[docNo],
        Reason: formDataSecondTab.Reason[docNo],
        isDisable: formDataSecondTab.isDisable[docNo],
        enteredReason: formDataSecondTab.enteredReason[docNo],
        DOC_NO: docNo,
        statement: statement,
      });
    }
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const callAPi = async () => {
    const acc = {
      accountNumber: `${formData.PAI_Account}`,
      firstName: `${formData.PAI_First_Name}`,
      surName: `${formData.PAI_Last_Name}`,
      emailId: `${formData.PAI_Email}`,
      phoneNumber: `${formData.PAI_Phone.split(" ").slice(1).join("-")}`,
    };
    const headers = {
      guestpaymentkey: `${process.env.NEXT_PUBLIC_API_KEY}`,
    };
    const iframeKey = await fetchFromAPI<GetAddNewPaymentApiKeyResponse>({
      method: "post",
      endpoint: `${process.env.NEXT_PUBLIC_PGW_ORIGIN}v1/iframeExternalKey`,
      body: acc,
      headers: headers,
    });
    setExternalKey(iframeKey);
    setGwUrl(
      `${process.env.NEXT_PUBLIC_PGW_ORIGIN}iframe-external-payment-method?iframeExternalKey=${iframeKey?.iframeKey}`
    );
  };

  useEffect(() => {
    callAPi();
  }, []);

  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  const reloadIframe = () => {
    setIframeLoad((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    const paymentMessage = async (event: MessageEvent) => {
      /*if (event.origin != process.env.NEXT_PUBLIC_PGW_URL) {
        setStep(2);
        toast.error(GP_ERROR_MSG);
        return;
      }*/

      if (event.data?.status === "success") {
        setIsLoading(true);
        setBackDisable(true);
        try {
          const card_name = event.data?.cc_name == "echeck" ? "ACH" : event.data?.cc_name || "";
          const card_type = event.data?.cc_type || "";

          const documentListItems = selectedInvoicesResponse
            .flatMap((invoice) => {
              let remainingInvoicePayment = Number.parseFloat(formDataSecondTab.Payment_amount[invoice.DOC_NO]);
              const sortedOpenItems = invoice.openItems!.sort((a, b) => {
                if (a.ITEM_TEXT === "LATEFEE") return 1; // Move "LATEFEE" items to the end of array
                if (b.ITEM_TEXT === "LATEFEE") return -1;
                return 0; // Maintain original order for other items that are not LATEFEE
              });

              return sortedOpenItems.map((openItem) => {
                let netwr = Number(openItem.AMOUNT);
                if (formDataSecondTab.Selected_option[invoice.DOC_NO]) {
                  if (remainingInvoicePayment > 0) {
                    if (remainingInvoicePayment >= netwr) {
                      remainingInvoicePayment -= netwr;
                    } else {
                      netwr = remainingInvoicePayment;
                      remainingInvoicePayment = 0;
                    }
                  } else {
                    netwr = 0;
                  }
                }
                return {
                  MANDT: "",
                  BUKRS: openItem?.COMP_CODE.toString(),
                  BELNR: openItem?.DOC_NO.toString(),
                  GJAHR: openItem?.FISC_YEAR.toString(),
                  BUZEI: openItem?.ITEM_NUM,
                  MERCHANT_REF_CODE: invoiceStatementLine.CUSTOMER ?? "", //SAP changes instead of invoiceStatementLine.CUSTOMER earlier it was invoice.ACCOUNT_ID
                  CCINS: card_name.toUpperCase(), //sap changes , earlier it was empty string ""
                  SUBSCRIPTIONID: event.data?.sub_id,
                  TOTAL_AMOUNT: openItem.TOT_AMOUNT.toString(),
                  NETWR: Number(netwr).toFixed(2).toString(),
                  WAERS: "",
                  KUNNR: invoiceStatementLine.CUSTOMER ?? "",
                  VBELN_VA: openItem.ALLOC_NMBR.toString(),
                  GUID: "",
                  SGTXT: "",
                  SOURCESYS: "MMWeb",
                  CRNAME: "",
                  CRDATE: "",
                  CRTIME: "",
                  AUTOPAY: "",
                  SHORTPAY_REASON: formDataSecondTab.Selected_option[invoice.DOC_NO] == "" ? "" : reasonCode,
                  SHORTPAY_REASON_TEXT:
                    formDataSecondTab.Selected_option[invoice.DOC_NO] == OTHERS_SELECT_OPTION_CODE.othersReasonCode
                      ? formDataSecondTab.enteredReason[invoice.DOC_NO]
                      : formDataSecondTab.Reason[invoice.DOC_NO],
                };
              });
            })
            .filter((item) => Number(item.NETWR) !== 0);

          const postBody = {
            CS_PAYMENT: {
              IN: {
                MERCHANT_REF_CODE: invoiceStatementLine.CUSTOMER ?? "",
                CURRENCY:
                  invoiceLineItems?.COMP_CODE === undefined ? "" : invoiceLineItems?.COMP_CODE === 1100 ? "CAD" : "USD",
                TOTALAMOUNT: sumOfPayment(formDataSecondTab.Payment_amount),
                SUBSCRIPTIONID: event.data?.sub_id,
                CCINS: card_name.toUpperCase(),
                BUKRS: invoiceLineItems?.COMP_CODE === undefined ? "" : invoiceLineItems?.COMP_CODE.toString(),
                GUID: "",
                REPROCESS: "",
                AUTOPAY: "",
                GUEST_PAYMENT_DELETE: "X",
                DOCLIST: {
                  item: documentListItems,
                },
                SOURCESYS: "MMWeb",
                LEVEL_2_3: "X",
              },
            },
          };

          const response = await postPayment(postBody);
          const cardDetails = {
            cardFullName: event.data?.cc_name || "",
            cardNumber: event.data?.cc_number || "",
            cardExpire: event.data?.cc_expire || "",
          };

          setPaymentSuccessResponse({ ...response, cardDetails });
          const invoicesPaymentSAPSuccessCondition =
            typeof response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY !== "string" &&
            response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY.item &&
            ((Array.isArray(response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY.item) &&
              response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY.item.length > 0 &&
              response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY.item.every(
                (lineItem: EtAccKeyItem) => lineItem.DECISION === "SUCCESS"
              )) ||
              (!Array.isArray(response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY.item) &&
                response["ZFI_CC_CS_PAYMENT.Response"].ET_ACCKEY.item.DECISION === "SUCCESS"));

          if (
            invoicesPaymentSAPSuccessCondition &&
            response?.["ZFI_CC_CS_PAYMENT.Response"]?.CS_PAYMENT?.OUT?.DECISION === "ACCEPT"
          ) {
            const transformedPayload = {
              email: formData.PAI_Email,
              firstName: formData.PAI_First_Name,
              lastName: formData.PAI_Last_Name,
              accountNumber: formData.PAI_Account,
              invoiceNumber: formData.PAI_Invoice,
              phone: formData.PAI_Phone.split(" ").slice(1).join("-"),
            };

            const api = new APIClient();
            if (filteredPartialPayments.length > 0) {
              try {
                isCheckedRef.current &&
                  userType &&
                  api
                    .post("/api/registration", transformedPayload)
                    .then(() => {
                      console.log("registration API is hit successfully");
                      setPortalAccountCreation(true);
                    })
                    .catch((err: any) => {
                      toast.error("Error submitting request");
                      console.log(err);
                    });
                for (const payment of filteredPartialPayments) {
                  await postPartialPayment(payment, formData);
                }
                setPartialPaymentSuccess(true);
              } catch (error) {
                console.error("Error posting partial payment:", error);
                setPartialPaymentSuccess(false);
                return;
              } finally {
                setStep(4);
                setIsLoading(false);
              }
            } else if (filteredPartialPayments.length === 0 && isCheckedRef.current && userType) {
              api
                .post("/api/registration", transformedPayload)
                .then(() => {
                  console.log("registration API is hit successfully");
                  setPortalAccountCreation(true);
                  setStep(4);
                  setIsLoading(false);
                })
                .catch((err: any) => {
                  toast.error("Error submitting request");
                  console.log(err);
                });
            } else {
              setStep(4);
              setIsLoading(false);
            }
            return;
          } else {
            setStep(2);
            toast.error(formDataTab.errorMessage);
            setBackDisable(false);
          }

          setIsLoading(false);
        } catch (error) {
          toast.error(formDataTab.errorMessage);
          setIsLoading(false);
          reloadIframe();
          setStep(3);
        }
      }
    };

    window.addEventListener("message", paymentMessage);
    return () => window.removeEventListener("message", paymentMessage);
  }, []);

  let globalLoader: any;
  if (typeof document !== "undefined") {
    globalLoader = document.getElementById("globalLoader");
  }

  return (
    <>
      {isLoading &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional semi-transparent overlay
              zIndex: 1000, // Ensure it's on top
              pointerEvents: isLoading ? "all" : "none",
              display: isLoading ? "block" : "none",
            }}
          >
            <div className="flex items-center justify-center w-full h-full">
              <LoadingDots />
            </div>
          </div>,
          globalLoader
        )}
      <div className="lg:col-span-10 lg:col-start-2 lg:px-10 col-span-4 px-6 pt-12 bg-white">
        <AppText type="SUB_HEADING_MEDIUM" className="mb-[28px]">
          {formDataTab.groups[0].heading}
        </AppText>
        {externalKey ? (
          <iframe src={gwUrl} key={iframeLoad} title="Payment" className="w-full h-[1000px] rounded-md no-scrollbar" />
        ) : (
          ""
        )}

        <div className={userType ? "mt-10 mb-[78px] flex justify-between" : "mt-10 mb-[78px]"}>
          <button id="targetSubmit" className="hidden" aria-label="submit target" type="submit"></button>
          {userType && (
            <div>
              <div className="flex gap-3">
                <input
                  type="checkbox"
                  className="w-[16px]"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <AppText type="SUB_HEADING_SMALL" className="text-center text-[#051C2C] font-[600] text-[15px]">
                  {formDataTab.groups[1]?.subHeading}
                </AppText>
              </div>
              <AppText
                type="SUB_HEADING_SMALL"
                className="max-w-[737px] font-saira font-[400] text-[14px] text-[#404040] py-[8px] text-left"
              >
                {formDataTab.groups[1]?.description}
              </AppText>
            </div>
          )}
          <div className="flex flex-row flex-wrap justify-end gap-4 bg-white">
            <AppButton
              intent="secondary"
              label={formDataTab.ctaBack}
              type="button"
              className="px-10"
              onMouseDown={() => {
                setStep(2);
              }}
              disabled={backDisable}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FormRequestPayAnInvoiceStep3;
